type AppEnv = 'LOCAL' | 'STAGING' | 'PRODUCTION' | 'DEMO';

const env = process.env.REACT_APP__APP_ENV as AppEnv;

export const AppConfig = {
    app: {
        port: Number(process.env.PORT),
        env,
        isLocal: env === 'LOCAL',
        isStaging: env === 'STAGING',
        isProd: env === 'PRODUCTION',
        isDemo: env === 'DEMO',
        apiUrl: process.env.REACT_APP__API_URL as string,
    },

    cookieTokenNames: {
        session: process.env.REACT_APP__SESSION_TOKEN_NAME as string,
        guest: process.env.REACT_APP__GUEST_TOKEN_NAME as string,
        auth: process.env.REACT_APP__AUTH_TOKEN_NAME as string,
        mbtsConsent: process.env.REACT_APP__MBTS_CONSENT_TOKEN_NAME as string,
    },
};